// theme-ajax.js
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const cartCloseBtn = document.getElementById('CartDrawerClose');
  
  // Expose global open/close
  window.openCartDrawer = function() {
    if(!cartDrawer) return;
    cartDrawer.classList.add('is-active');
    cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    updateCartDrawer();
  }

  window.closeCartDrawer = function() {
    if(!cartDrawer) return;
    cartDrawer.classList.remove('is-active');
    cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if(cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Update Cart Drawer via Shopify Ajax API
  window.updateCartDrawer = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCartItems(cart);
        updateCartBadge(cart.item_count);
      })
      .catch(error => console.error('Cart Error:', error));
  }

  function renderCartItems(cart) {
    const itemsContainer = document.getElementById('CartDrawerItems');
    const emptyState = document.querySelector('.cart-drawer-empty');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    
    if(cart.item_count === 0) {
      itemsContainer.innerHTML = '';
      emptyState.style.display = 'block';
      if(subtotalEl) subtotalEl.innerHTML = '0.00 TL';
      return;
    }

    emptyState.style.display = 'none';
    
    let html = '';
    cart.items.forEach((item, index) => {
      const price = (item.price / 100).toFixed(2) + ' TL';
      html += `
        <div class="cart-drawer-item">
          <div class="cart-item-image">
            <img src="${item.image}" alt="${item.product_title}">
          </div>
          <div class="cart-item-details">
            <h3 class="cart-item-title"><a href="${item.url}">${item.product_title}</a></h3>
            ${item.variant_title ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
            <div class="cart-item-price-qty">
              <span class="cart-item-price">${price}</span>
              <div class="cart-item-qty">
                <button type="button" onclick="changeItemQty(${index + 1}, ${item.quantity - 1})">-</button>
                <input type="number" value="${item.quantity}" readonly>
                <button type="button" onclick="changeItemQty(${index + 1}, ${item.quantity + 1})">+</button>
              </div>
            </div>
            <button type="button" class="cart-item-remove" onclick="changeItemQty(${index + 1}, 0)">Kaldır</button>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = html;
    if(subtotalEl) subtotalEl.innerHTML = (cart.total_price / 100).toFixed(2) + ' TL';
  }

  window.changeItemQty = function(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      renderCartItems(cart);
      updateCartBadge(cart.item_count);
    });
  }

  function updateCartBadge(count) {
    const badges = document.querySelectorAll('.cart-count-badge');
    badges.forEach(badge => {
      badge.textContent = count;
      if(count > 0) badge.style.display = 'flex';
    });
  }

  // Intercept Add To Cart Forms
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitBtn = form.querySelector('[type="submit"]');
      if(submitBtn) {
        submitBtn.innerHTML = 'Ekleniyor...';
        submitBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(response => response.json())
      .then(item => {
        if(submitBtn) {
          submitBtn.innerHTML = 'Sepete Eklendi';
          setTimeout(() => {
            submitBtn.innerHTML = 'Sepete Ekle';
            submitBtn.disabled = false;
          }, 2000);
        }
        openCartDrawer();
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        if(submitBtn) {
          submitBtn.innerHTML = 'Sepete Ekle';
          submitBtn.disabled = false;
        }
      });
    });
  });
});
